export enum FormCategoryEnum {
  Login = 0,
  SignUp = 1,
}
